// extracted by mini-css-extract-plugin
export default {"filtersContainer":"CoverageFilters_filtersContainer__U8cK+","wrapper":"CoverageFilters_wrapper__D87HZ","secondaryWrapper":"CoverageFilters_secondaryWrapper__eQ3mb"};